import React from "react";
import { Modify } from "src/@types/common";

type HeaderProps = Modify<
  React.ComponentPropsWithoutRef<"h1">,
  Partial<{
    fontFamily: Array<string>;
    fontWeight: Array<string>;
    fontSize: Array<string>;
    lineHeight: Array<string>;
    textAlign: Array<string>;
    letterSpacing: Array<string>;
    color: Array<string>;
  }>
>;

const Header: React.FC<HeaderProps> = (props) => {
  const {
    children,
    fontFamily = ["Roboto", "Lexend"],
    fontSize = ["24px", "52px"],
    fontWeight = ["700", "700"],
    lineHeight = ["28px", "64px"],
    letterSpacing = ["normal", "normal"],
    textAlign = ["left", "left"],
    color = ["#383838", "#383838"],
  } = props;

  return (
    <React.Fragment>
      <h1 className="header">{children}</h1>
      <style jsx scoped>{`
        .header {
          color: #383838;

          font-family: ${fontFamily[0]};
          font-size: ${fontSize[0]};
          font-weight: ${fontWeight[0]};
          line-height: ${lineHeight[0]};
          text-align: ${textAlign[0]};
          letter-spacing: ${letterSpacing[0]};
          color: ${color[0]};
          letter-spacing: -0.24px;
        }

        @media only screen and (min-width: 480px) {
          .header {
            font-family: ${fontFamily[1]};
            font-size: ${fontSize[1]};
            font-weight: ${fontWeight[1]};
            line-height: ${lineHeight[1]};
            text-align: ${textAlign[1]};
            letter-spacing: ${letterSpacing[1]};
            color: ${color[1]};
            letter-spacing: 0.005em;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export default Header;
